/**
 * Lap Analysis Stage
 *
 * Performs lap analysis including:
 * - Computing braking points
 * - Computing slowest points
 * - Calculating top speed per lap
 *
 * This stage must run after LapProcessingStage.
 */

import {
  PipelineStage,
  PipelineContext,
  StageResult,
} from '../ProcessingPipeline'
import { computeBreakingPoints } from '../../../domain/lap/lapAnalysis'

export class LapAnalysisStage implements PipelineStage {
  name = 'Lap Analysis'

  async execute(context: PipelineContext): Promise<StageResult<void>> {
    const warnings: string[] = []

    try {
      const { laps } = context

      if (!laps || laps.length === 0) {
        return {
          success: false,
          error: 'No laps available for analysis',
        }
      }

      // Analyze each lap
      for (const lap of laps) {
        try {
          const result = computeBreakingPoints(lap)
          lap.breakingPoints = result.breakingPoints
          lap.slowestPoints = result.slowestPoints
          lap.topSpeed = result.topSpeed
        } catch (error) {
          warnings.push(
            `Failed to analyze lap ${lap.lapNumber}: ${
              error instanceof Error ? error.message : String(error)
            }`
          )
        }
      }

      return {
        success: true,
        warnings: warnings.length > 0 ? warnings : undefined,
      }
    } catch (error) {
      return {
        success: false,
        error: `Lap analysis failed: ${error instanceof Error ? error.message : String(error)}`,
      }
    }
  }
}
